Vue.component('QuestForm', {
    template: templates.QuestForm,
    props: {
        model: {
            type: Object,
            required: true
        },
        cards: {
            type: Object,
            required: true
        },
        packs: {
            type: Object,
            required: true
        },
        randomcard: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            // Remove localModel to avoid circular updates
        };
    },
    computed: {
        // Fixed: These should be inside computed
        questModel() {
            return this.model || {};
        },
        cardAmount() {
            return this.model.card_amount || 0;
        }
    },
    methods: {
        // Emit changes directly without storing local copies
        updateField(field, value) {
            this.$emit('input-changed', { 
                model: { 
                    ...this.model, 
                    [field]: value 
                } 
            });
        },
        
        incrementCards() {
            const newCards = [...(this.model.cards || [])];
            newCards.push({ cardId: null, tier: 0 });
            
            this.$emit('input-changed', { 
                model: { 
                    ...this.model, 
                    card_amount: (this.model.card_amount || 0) + 1,
                    cards: newCards
                } 
            });
        },
        
        removeCard(index) {
            if (this.cardAmount > 0) {
                const newCards = [...this.model.cards];
                newCards.splice(index, 1);
                
                this.$emit('input-changed', { 
                    model: { 
                        ...this.model, 
                        card_amount: this.cardAmount - 1,
                        cards: newCards
                    } 
                });
            }
        },
        
        updateCard(index, field, value) {
            const newCards = [...(this.model.cards || [])];
            
            // Ensure the card object exists with proper defaults
            if (!newCards[index]) {
                newCards[index] = { cardId: null, tier: 0 };
            }
            
            // Preserve existing card data and only update the specific field
            newCards[index] = { 
                ...newCards[index], 
                [field]: field === 'tier' ? parseInt(value) || 0 : value 
            };
            
            // If selecting a card, also add the card name
            if (field === 'cardId' && value && this.cards[value]) {
                newCards[index].name = this.cards[value].name;
            }
            
            this.$emit('input-changed', { 
                model: { 
                    ...this.model, 
                    card_amount: (this.model.card_amount || 0) + 1,
                    cards: newCards 
                } 
            });
        },

        handleRewardChange(rewardData) {
            console.log(rewardData)
            this.$emit('input-changed', { 
                model: { 
                    ...this.model, 
                    ...rewardData 
                } 
            });
        }
    }
});